module.exports = __webpack_public_path__ + "static/media/cloud.46355b18.png";